import { Controller } from "stimulus";
import { scaleLinear, scaleTime } from "d3-scale";
import { select, selectAll, mouse } from "d3-selection";
import _partialRight from "lodash/partialRight";
import _debounce from "lodash/debounce";
import { jsx } from "react/jsx-runtime";
import React from "react";
import { DataFetchProvider, StimulusAppBootstrapper, track } from "@betterment/js-runtime";
import { Flex, Loader, GlobalErrorFallback, StyleClosetThemeProvider } from "@betterment/style-closet-react";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { extent, bisector } from "d3-array";
import { axisBottom, axisRight } from "d3-axis";
import { format } from "d3-format";
import { curveBasis, line, area } from "d3-shape";
import { timeFormat } from "d3-time-format";
import * as Sentry$1 from "@sentry/browser";
import { definitionsFromGlob } from "stimulus-vite-helpers";
import TestTrack from "test_track_js_client";
const CONFIRMATION_MODAL_SELECTOR = "[data-sc-modal-content='mutual-fund-warning']";
class acats_assets_selection_controller_default extends Controller {
  showAddCashLink() {
    this.addCashLinkTarget.classList.remove("u-displayNone");
    this.addCashLinkTarget.classList.add("u-displayBlock");
  }
  submit(event) {
    if (this.hasConfirmationRequiredAssetTarget && !this.confirmationModalTarget.classList.contains("is-open")) {
      event.stopPropagation();
      event.preventDefault();
      this.confirmationModalTriggerTarget.click();
    }
  }
  toggleTermsAcceptance() {
    this.confirmed = !this.confirmed;
    this.confirmationModalSubmitButtonTarget.disabled = !this.confirmed;
  }
  saveAssets() {
    const $assetsCollectionFormTarget = $(this.assetsCollectionFormTarget);
    const url = $assetsCollectionFormTarget.data("remote-action");
    const data = $assetsCollectionFormTarget.serialize();
    void $.ajax({
      type: "PUT",
      url,
      data
    }).catch();
  }
  removeCashAsset() {
    this.cashAssetRowTarget.remove();
    this.showAddCashLink();
    this.validate();
  }
  updateShares() {
    if (this.cashAllSharesCheckboxTarget.checked) {
      this.clearSharesInput();
      this.disableSharesInput();
    } else {
      this.enableSharesInput();
    }
  }
  enableSharesInput() {
    this.cashAllSharesCheckboxTarget.checked = false;
    this.cashSharesInputTarget.classList.remove("is-blocked");
    this.cashSharesInputTarget.focus();
  }
  clearSharesInput() {
    this.cashSharesInputTarget.value = "";
  }
  disableSharesInput() {
    this.cashSharesInputTarget.classList.add("is-blocked");
  }
  anyAssets() {
    return !!(this.hasCashSharesInputTarget || this.hasSharesInputTarget);
  }
  toggleErrorMessage() {
    if (this.anyAssets()) {
      this.assetErrorDivTarget.classList.add("u-displayNone");
    } else {
      this.assetErrorDivTarget.classList.remove("u-displayNone");
    }
  }
  get confirmationModalTriggerTarget() {
    return this.submitButtonTarget.parentElement;
  }
  enableConfirmationModalTrigger() {
    this.confirmationModalTriggerTarget.dataset.scModalTarget = CONFIRMATION_MODAL_SELECTOR;
  }
  disableConfirmationModalTrigger() {
    if (this.confirmationModalTriggerTarget.dataset.scModalTarget) {
      delete this.confirmationModalTriggerTarget.dataset.scModalTarget;
    }
  }
  toggleConfirmationModalTrigger() {
    if (this.hasConfirmationRequiredAssetTarget || !this.anyAssets()) {
      this.enableConfirmationModalTrigger();
    } else {
      this.disableConfirmationModalTrigger();
    }
  }
  validate() {
    this.toggleConfirmationModalTrigger();
  }
  modalProperMessage() {
    if (this.anyAssets()) {
      this.modalNoSecuritiesEnteredMessageTarget.hidden = true;
      this.modalNotAllCashMessageTarget.hidden = false;
    } else {
      this.modalNotAllCashMessageTarget.hidden = true;
      this.modalNoSecuritiesEnteredMessageTarget.hidden = false;
    }
  }
  connect() {
    this.confirmed = false;
    this.validate();
    this.modalProperMessage();
  }
}
acats_assets_selection_controller_default.targets = [
  "addCashLink",
  "cashSharesInput",
  "cashAllSharesCheckbox",
  "sharesInput",
  "submitButton",
  "assetsCollectionForm",
  "cashAssetRow",
  "confirmationModal",
  "confirmationRequiredAsset",
  "assetErrorDiv",
  "agreementCheckBox",
  "confirmationModalSubmitButton",
  "modalNoSecuritiesEnteredMessage",
  "modalNotAllCashMessage"
];
const __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: acats_assets_selection_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class add_account_solo_401k_tcp_controller_default extends Controller {
  connect() {
    this.accountTypeChanged();
  }
  accountTypeChanged() {
    const { value } = this.accountTypeInputTarget;
    this.hideOrShowTcpFlash(value);
  }
  hideOrShowTcpFlash(value) {
    if (value === "solo_401k") {
      this.setTcpFlashHidden(false);
    } else {
      this.setTcpFlashHidden(true);
    }
  }
  setTcpFlashHidden(hidden) {
    this.tcpFlashTarget.hidden = hidden;
  }
}
add_account_solo_401k_tcp_controller_default.values = {
  hasTcpGoal: String
};
add_account_solo_401k_tcp_controller_default.targets = ["accountTypeInput", "tcpFlash"];
const __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: add_account_solo_401k_tcp_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const getCsrfToken = () => {
  const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
  if (csrfTokenMeta) {
    return csrfTokenMeta.content;
  }
  return null;
};
class advisor_announcement_controller_default extends Controller {
  connect() {
    this.closeIcon = this.modalTarget.querySelector(".sc-Modal-close");
    if (this.closeIcon) {
      this.closeIcon.addEventListener("click", () => {
        this.close();
      });
      this.modalTarget.classList.add("is-open");
    }
  }
  saveModelDismiss() {
    void fetch(this.data.get("dismissUrl"), {
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "X-REQUESTED-WITH": "XMLHttpRequest",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      method: "post"
    });
  }
  closeAndRedirect() {
    this.closeIcon.click();
    const redirectValue = this.data.get("redirectValue");
    if (redirectValue) {
      window.open(redirectValue, this.data.get("redirectTarget") || "_blank");
    }
  }
  close() {
    this.saveModelDismiss();
  }
}
advisor_announcement_controller_default.values = {
  redirect: String,
  dismissUrl: String,
  redirectTarget: String
};
advisor_announcement_controller_default.targets = ["welcome", "modal"];
const __vite_glob_0_2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: advisor_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class advisor_crypto_goal_confirm_controller_default extends Controller {
  connect() {
    this.determineButtonState();
  }
  toggleCryptoAgreementAccepted() {
    this.determineButtonState();
  }
  determineButtonState() {
    if (this.cryptoAgreementAcceptedTarget.checked) {
      this.createAccountButtonTarget.disabled = false;
    } else {
      this.createAccountButtonTarget.disabled = true;
    }
  }
}
advisor_crypto_goal_confirm_controller_default.targets = ["cryptoAgreementAccepted", "createAccountButton"];
const __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: advisor_crypto_goal_confirm_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class advisor_goal_creation_flow_account_ownership_configuration_controller_default extends Controller {
  connect() {
    this.accountTypeSelectElementTarget.addEventListener("change", this.accountTypeSelected.bind(this));
    this.primaryUserSelectElementTarget.addEventListener("change", this.primaryUserChange.bind(this));
    this.accountTypeSelected({ target: this.accountTypeSelectElementTarget });
    this.userSelectionChange(this.secondaryUserSelectElementTarget, this.primaryUserSelectElementTarget.value);
    this.conformSecondaryUserSelection(this.primaryUserSelectElementTarget);
    this.step = "accountType";
  }
  jointAccountType() {
    this.secondaryUserContainerTarget.classList.remove("hidden");
  }
  individualAccountType() {
    this.secondaryUserContainerTarget.classList.add("hidden");
  }
  primaryUserChange({ target }) {
    this.userSelectionChange(this.secondaryUserSelectElementTarget, target.value);
    this.conformSecondaryUserSelection(target.value);
  }
  conformSecondaryUserSelection(value) {
    if (value === this.secondaryUserSelectElementTarget.value) {
      const option = this.secondaryUserSelectElementTarget.querySelector(
        `option:not([value="${value}"])`
      );
      this.secondaryUserSelectElementTarget.value = String(option.value);
    }
  }
  userSelectionChange(elementToChange, value) {
    elementToChange.querySelector(`option[value="${value}"]`).classList.add("hidden");
    const rest = Array.from(elementToChange.querySelectorAll(`option:not([value="${value}"])`));
    rest.forEach((element) => {
      element.classList.remove("hidden");
    });
    this.step = "secondaryUser";
  }
  accountTypeSelected({ target }) {
    switch (target.value) {
      case "joint":
        this.jointAccountType();
        this.conformSecondaryUserSelection(this.primaryUserSelectElementTarget.value);
        break;
      case "individual":
      case "trust":
        this.individualAccountType();
        break;
    }
    this.step = "secondaryUser";
  }
  changeStep(e = null) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  submitForm() {
    this.formElementTarget.submit();
  }
}
advisor_goal_creation_flow_account_ownership_configuration_controller_default.targets = [
  "formElement",
  "primaryUserSelectElement",
  "accountTypeSelectElement",
  "secondaryUserContainer",
  "secondaryUserSelectElement",
  "submitButton"
];
const __vite_glob_0_4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: advisor_goal_creation_flow_account_ownership_configuration_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class asset_row_controller_default extends Controller {
  removeAsset() {
    this.assetRowTarget.remove();
    window.dispatchEvent(new CustomEvent("asset-row:removed"));
  }
  updateShares() {
    if (this.allSharesCheckboxTarget.checked) {
      this.clearSharesInput();
      this.disableSharesInput();
    } else {
      this.enableSharesInput();
    }
  }
  enableSharesInput() {
    this.allSharesCheckboxTarget.checked = false;
    this.sharesInputTarget.classList.remove("is-blocked");
    this.sharesInputTarget.focus();
  }
  clearSharesInput() {
    this.sharesInputTarget.value = "";
  }
  disableSharesInput() {
    this.sharesInputTarget.classList.add("is-blocked");
  }
}
asset_row_controller_default.targets = ["sharesInput", "allSharesCheckbox", "assetRow"];
const __vite_glob_0_5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: asset_row_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class billing_configuration_rate_fields_controller_default extends Controller {
  isInteger(value) {
    return parseInt(value, 10) === parseFloat(value);
  }
  formatMoney(inputNumber) {
    const inputToNumber = parseFloat(inputNumber);
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(inputToNumber);
  }
  platformFeeAmount() {
    return parseInt(this.platformFeeDivTarget.dataset.platformfee, 10);
  }
  assetBasedTotalRateUpdatedAmount(userText) {
    if (this.isInteger(userText)) {
      const totalAmount = parseInt(userText, 10) + this.platformFeeAmount();
      return `${totalAmount} bps`;
    }
    return this.platformFeeDivTarget.innerText;
  }
  fixedTotalRateUpdatedAmount(userText) {
    const cleanedText = this.cleanInputString(userText);
    if (this.isInteger(cleanedText)) {
      return `${this.formatMoney(cleanedText)} + ${this.platformFeeDivTarget.innerText}`;
    }
    return this.platformFeeDivTarget.innerText;
  }
  updatedText(configurationType) {
    switch (configurationType) {
      case "assetBased":
        return this.assetBasedTotalRateUpdatedAmount(this.assetBasedRateInputTarget.value);
      case "fixed":
        return this.fixedTotalRateUpdatedAmount(this.fixedRateInputTarget.value);
      default:
        return "";
    }
  }
  overwriteTotalRate() {
    this.totalRateDivTarget.innerText = this.updatedText(this.totalRateDivTarget.dataset.configuration);
  }
  cleanInputString(userText) {
    return userText.replace(/,/g, "");
  }
}
billing_configuration_rate_fields_controller_default.targets = ["assetBasedRateInput", "fixedRateInput", "platformFeeDiv", "totalRateDiv"];
const __vite_glob_0_6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: billing_configuration_rate_fields_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const SEGMENT_SPACING = 4;
class BulletChart {
  constructor(element, options) {
    const DEFAULTS = {
      margin: {
        left: 0,
        top: 0,
        right: 5,
        bottom: 0
      },
      graphHeight: Math.min(0.3 * element.parentElement.clientWidth, 75)
    };
    this.settings = { ...DEFAULTS, ...options, element };
    this.settings.width = this.settings.element.parentElement.clientWidth - this.settings.margin.right;
    this.settings.height = this.settings.graphHeight - this.settings.margin.top - this.settings.margin.bottom;
  }
  draw() {
    this.setUpScales();
    this.emptyLayout();
    this.createLayout();
    this.drawData();
  }
  setUpScales() {
    this.scales = {
      x: scaleLinear().domain([0, 1])
    };
  }
  emptyLayout() {
    const svg = this.settings.element;
    while (svg.firstChild) {
      svg.removeChild(svg.firstChild);
    }
  }
  createLayout() {
    this.svg = select(this.settings.element).attr("width", this.settings.element.parentElement.clientWidth).attr("height", this.settings.height + this.settings.margin.top + this.settings.margin.bottom).append("g").attr("transform", `translate(${this.settings.margin.left},${this.settings.margin.top})`);
    this.svg.append("rect").attr("y", this.center - this.barHeight / 2).attr("width", this.settings.width).attr("height", this.barHeight).attr("class", "BulletChart-chartBackground");
  }
  drawArea() {
    this.svg.append("rect").attr("y", this.center - this.barHeight / 2).attr("width", this.settings.width * this.settings.measure).attr("height", this.barHeight).attr("class", `BulletChart-chart BulletChart-chart--${this.settings.status}`);
  }
  drawSections() {
    const { width, sections } = this.settings;
    const barY = this.center - this.barHeight / 2;
    const endRadius = 2;
    const leftSection = sections[0];
    const rightSection = sections[sections.length - 1];
    const leftSectionWidth = width * (leftSection.end - leftSection.start) - SEGMENT_SPACING;
    this.svg.append("path").attr("class", `BulletChart-chart BulletChart-chart--${leftSection.status}`).attr(
      "d",
      `
          M ${leftSectionWidth} ${barY}
          v ${this.barHeight}
          h -${leftSectionWidth - endRadius}
          q -${endRadius} 0 -${endRadius} -${endRadius}
          v -${this.barHeight - endRadius * 2}
          q 0 -${endRadius} ${endRadius} -${endRadius}
          h ${leftSectionWidth - endRadius}
        `
    );
    sections.slice(1, -1).forEach((section) => {
      const sectionWidth = width * (section.end - section.start) - SEGMENT_SPACING;
      this.svg.append("path").attr("class", `BulletChart-chart BulletChart-chart--${section.status}`).attr(
        "d",
        `
            M ${width * section.start} ${barY}
            h ${sectionWidth}
            v ${this.barHeight}
            h -${sectionWidth}
            v -${this.barHeight}
          `
      );
    });
    const rightSectionWidth = width - width * rightSection.start;
    this.svg.append("path").attr("class", `BulletChart-chart BulletChart-chart--${rightSection.status}`).attr(
      "d",
      `
          M ${width - rightSectionWidth} ${barY}
          h ${rightSectionWidth - endRadius}
          q ${endRadius} 0 ${endRadius} ${endRadius}
          v ${this.barHeight - endRadius * 2}
          q 0 ${endRadius} -${endRadius} ${endRadius}
          h -${rightSectionWidth - endRadius}
          v -${this.barHeight}
        `
    );
  }
  drawMeasure() {
    const measureHeight = this.barHeight * 3;
    const measureY = this.center - measureHeight / 2;
    this.svg.append("rect").attr("height", measureHeight).attr("width", 8).attr("y", measureY).attr("x", this.settings.width * this.settings.measure - SEGMENT_SPACING / 2).attr("class", "BulletChart-markerBackground");
    this.svg.append("rect").attr("height", measureHeight).attr("width", SEGMENT_SPACING).attr("y", measureY).attr("ry", 2).attr("x", this.settings.width * this.settings.measure).attr("rx", 2).attr("class", "BulletChart-marker");
  }
  drawOptionalMeasure() {
    const measureHeight = this.barHeight * 3;
    const measureY = this.center - measureHeight / 2;
    this.svg.append("rect").attr("height", measureHeight).attr("width", 8).attr("y", measureY).attr("x", this.settings.width * this.settings.optionalMeasure - SEGMENT_SPACING / 2).attr("class", "BulletChart-markerBackground");
    this.svg.append("rect").attr("height", measureHeight).attr("width", 2).attr("y", measureY).attr("ry", 2).attr("x", this.settings.width * this.settings.optionalMeasure).attr("rx", 2).attr("class", "BulletChart-optionalMarker");
    this.svg.append("text").attr("class", "BulletChart-optionalMarkerLabel").attr("alignment-baseline", "hanging").attr("x", this.settings.width * this.settings.optionalMeasure).attr("y", this.center + this.barHeight / 2 + this.labelHeight).text(this.settings.optionalMeasureLabel);
  }
  drawLabels() {
    this.svg.append("text").attr("class", "BulletChart-label").attr("alignment-baseline", "hanging").attr("x", 0).attr("y", this.center + this.barHeight / 2 + this.labelHeight).text(this.settings.minLabel);
    this.svg.append("text").attr("class", "BulletChart-label").attr("alignment-baseline", "hanging").attr("text-anchor", "end").attr("x", this.settings.width).attr("y", this.center + this.barHeight / 2 + this.labelHeight).text(this.settings.maxLabel);
  }
  drawData() {
    this.drawSections();
    this.drawMeasure();
    if (this.settings.optionalMeasure) {
      this.drawOptionalMeasure();
    }
    if (this.settings.minLabel || this.settings.maxLabel) {
      this.drawLabels();
    }
  }
  get center() {
    return this.settings.height / 2;
  }
  get barHeight() {
    return 8;
  }
  get labelHeight() {
    return 10;
  }
}
class bullet_chart_controller_default extends Controller {
  connect() {
    this.draw();
    this.connectResizeListener();
  }
  disconnect() {
    this.disconnectResizeListener();
  }
  draw() {
    const chart = new BulletChart(this.svgTarget, this.graphOptions);
    chart.draw();
  }
  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener("resize", this.resizeListener);
  }
  disconnectResizeListener() {
    window.removeEventListener("resize", this.resizeListener);
  }
  get graphOptions() {
    return {
      minLabel: this.data.get("min-label"),
      maxLabel: this.data.get("max-label"),
      measure: parseFloat(this.data.get("measure")),
      sections: JSON.parse(this.data.get("sections")),
      status: this.data.get("status"),
      optionalMeasure: parseFloat(this.data.get("optional-measure")),
      optionalMeasureLabel: this.data.get("optional-measure-label")
    };
  }
}
bullet_chart_controller_default.targets = ["svg"];
const __vite_glob_0_7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bullet_chart_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class client_envelope_announcement_controller_default extends Controller {
  connect() {
    this.closeIcon = this.modalTarget.querySelector(".sc-Modal-close");
    if (this.closeIcon) {
      this.closeIcon.addEventListener("click", () => {
        this.close();
      });
      this.modalTarget.classList.add("is-open");
    }
  }
  financialAccountsStep() {
    this.toggleStep(this.welcomeTarget);
    this.toggleStep(this.financialAccountsTarget);
  }
  clientAccountsStep() {
    this.toggleStep(this.financialAccountsTarget);
    this.toggleStep(this.clientAccountsTarget);
  }
  completionStep() {
    this.toggleStep(this.clientAccountsTarget);
    this.toggleStep(this.completionTarget);
  }
  toggleStep(el) {
    el.classList.toggle("u-displayNone");
  }
  saveModelDismiss() {
    void fetch(this.data.get("dismissUrl"), {
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "X-REQUESTED-WITH": "XMLHttpRequest",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      method: "post"
    });
  }
  closeAndRedirect() {
    this.closeIcon.click();
    window.location.href = this.data.get("redirectValue");
  }
  close() {
    this.saveModelDismiss();
  }
}
client_envelope_announcement_controller_default.values = {
  redirect: String,
  dismissUrl: String
};
client_envelope_announcement_controller_default.targets = ["welcome", "financialAccounts", "clientAccounts", "completion", "modal"];
const __vite_glob_0_8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: client_envelope_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const parseInteger = _partialRight(parseInt, 10);
const copyToClipboard = (element) => {
  element.select();
  document.execCommand("copy");
};
class clipboard_controller_default extends Controller {
  copy(event) {
    event.preventDefault();
    copyToClipboard(this.linkTarget);
    this.successTextTarget.classList.remove("u-hidden");
  }
}
clipboard_controller_default.targets = ["link", "successText"];
const __vite_glob_0_9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clipboard_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class custom_model_portfolios_announcement_controller_default extends Controller {
  connect() {
    this.closeIcon = this.modalTarget.querySelector(".sc-Modal-close");
    if (this.closeIcon) {
      this.closeIcon.addEventListener("click", () => {
        this.close();
      });
      this.modalTarget.classList.add("is-open");
    }
  }
  tickersStep() {
    this.toggleStep(this.welcomeTarget);
    this.toggleStep(this.tickersTarget);
  }
  riskLevelsStep() {
    this.toggleStep(this.tickersTarget);
    this.toggleStep(this.riskLevelsTarget);
  }
  completionStep() {
    this.toggleStep(this.riskLevelsTarget);
    this.toggleStep(this.completionTarget);
  }
  toggleStep(el) {
    el.classList.toggle("u-displayNone");
  }
  saveModelDismiss() {
    void fetch(this.data.get("dismissUrlValue"), {
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "X-REQUESTED-WITH": "XMLHttpRequest",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      method: "post"
    });
  }
  closeAndRedirect() {
    this.saveModelDismiss();
    window.location.href = this.data.get("redirectValue");
  }
  close() {
    this.saveModelDismiss();
  }
}
custom_model_portfolios_announcement_controller_default.values = {
  redirect: String,
  dismissUrl: String
};
custom_model_portfolios_announcement_controller_default.targets = ["welcome", "tickers", "riskLevels", "completion", "modal"];
const __vite_glob_0_10 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: custom_model_portfolios_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class datum_mask_controller_default extends Controller {
  showUnmaskedDatum() {
    const maskedElement = this.maskedElementTarget;
    const { unmaskedDatum } = maskedElement.dataset;
    maskedElement.innerHTML = unmaskedDatum;
  }
}
datum_mask_controller_default.targets = ["maskedElement"];
const __vite_glob_0_11 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: datum_mask_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class disassociation_modal_controller_default extends Controller {
  change() {
    this.submitButtonTarget.disabled = !this.confirmCheckboxTarget.checked;
  }
}
disassociation_modal_controller_default.targets = ["submitButton", "confirmCheckbox"];
const __vite_glob_0_12 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: disassociation_modal_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const PULSE_BUTTON_OFFSET = 5;
class feature_tour_controller_default extends Controller {
  connect() {
    this.resizeListener = _debounce(this.resizeSteps.bind(this), 50);
    window.addEventListener("resize", this.resizeListener);
    this.resizeSteps();
  }
  resizeSteps() {
    this.stepTargets.forEach((step) => this.positionStep(step));
  }
  positionStep(step) {
    const offset = step.classList.contains("right") ? -PULSE_BUTTON_OFFSET : PULSE_BUTTON_OFFSET;
    const anchorElement = document.querySelector(step.getAttribute("data-tour-selector"));
    const anchorCoords = anchorElement.getBoundingClientRect();
    step.style.top = `${anchorCoords.top - offset}px`;
    const navElement = document.querySelector(".ApplicationLayout-nav");
    if (navElement.contains(anchorElement)) {
      step.style.left = `${anchorCoords.left + (step.classList.contains("right") ? anchorCoords.width : 0) - offset}px`;
    } else {
      step.style.left = `${anchorCoords.left - navElement.offsetWidth + (step.classList.contains("right") ? anchorCoords.width : 0) - offset}px`;
    }
  }
  dismiss() {
    this.stepTargets.forEach((step) => {
      step.hidden = true;
    });
  }
}
feature_tour_controller_default.targets = ["step"];
const __vite_glob_0_13 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: feature_tour_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class firm_fee_configuration_acceptance_controller_default extends Controller {
  toggleTermsAcceptance() {
    this.submitButtonTarget.disabled = !this.agreementCheckBoxTarget.checked;
  }
}
firm_fee_configuration_acceptance_controller_default.targets = ["agreementCheckBox", "submitButton"];
const __vite_glob_0_14 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: firm_fee_configuration_acceptance_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const STRIPE_API_ERROR_RETRIES = 2;
class firm_fee_configuration_acceptance_stripe_controller_default extends Controller {
  connect() {
    this.countdown = 0;
    try {
      this.stripe = window.Stripe(this.getPublishableKey());
      this.elements = this.stripe.elements({
        clientSecret: this.getClientSecret()
      });
      const cardElement = this.elements.create("payment");
      cardElement.mount(`#${this.cardElementTarget.id}`);
    } catch (e) {
      this.hideAndUnblock();
    }
  }
  toggleTermsAcceptance() {
    this.stripeSubmitButtonTarget.disabled = !this.agreementCheckBoxTarget.checked;
  }
  async stripeSubmitForm() {
    if (this.countdown < STRIPE_API_ERROR_RETRIES) {
      this.lockButton();
      await this.connectedSubmit();
    } else {
      this.disconnectedSubmit();
    }
  }
  async connectedSubmit() {
    const errorMessage = this.stripeErrorElementTarget;
    const messageContainer = this.stripeErrorContainerTarget;
    try {
      const { setupIntent, error } = await this.stripe.confirmSetup({
        elements: this.elements,
        redirect: "if_required"
      });
      if (error) {
        if (error.type !== "validation_error") {
          if (error.type !== "card_error") {
            this.countdownPlus();
          }
          errorMessage.textContent = error.message;
        } else {
          errorMessage.textContent = "There was an error saving your payment information. Please try again.";
        }
        messageContainer.classList.remove("u-displayNone");
        this.unlockButton();
      } else {
        this.statusIntent();
      }
    } catch (e) {
      this.unlockButton();
      this.countdownPlus();
    }
  }
  countdownPlus() {
    this.countdown++;
    if (this.countdown >= STRIPE_API_ERROR_RETRIES) {
      this.hideAndUnblock();
    }
  }
  disconnectedSubmit() {
    this.formTarget.submit();
  }
  lockButton() {
    this.stripeSubmitButtonTarget.textContent = "Continuing...";
    this.stripeSubmitButtonTarget.disabled = true;
  }
  unlockButton() {
    this.stripeSubmitButtonTarget.textContent = "Agree and continue";
    this.stripeSubmitButtonTarget.disabled = !this.agreementCheckBoxTarget.checked;
  }
  statusIntent() {
    this.stripe.retrieveSetupIntent(this.getClientSecret()).then(({ setupIntent }) => {
      const errorMessage = this.stripeErrorElementTarget;
      if (setupIntent.status === "requires_payment_method") {
        errorMessage.innerText = "Failed to process payment details. Please try another payment method.";
        this.unlockButton();
      } else {
        this.formTarget.submit();
      }
    });
  }
  getClientSecret() {
    return this.cardFormTarget.dataset.secret;
  }
  getPublishableKey() {
    return this.cardFormTarget.dataset.key;
  }
  hideAndUnblock() {
    this.countdown = STRIPE_API_ERROR_RETRIES;
    document.querySelector("#payment-method-info").remove();
  }
}
firm_fee_configuration_acceptance_stripe_controller_default.targets = [
  "cardElement",
  "stripeErrorElement",
  "stripeErrorContainer",
  "cardForm",
  "form",
  "agreementCheckBox",
  "stripeSubmitButton"
];
const __vite_glob_0_15 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: firm_fee_configuration_acceptance_stripe_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class firm_registration_controller_default extends Controller {
  connect() {
    this.determineAgreementLink();
    this.determinePasswordConfirmationState();
  }
  onFourOhOneToggle() {
    this.determineAgreementLink();
  }
  determineAgreementLink() {
    if (this.fourOhOneInputTarget.checked) {
      this.agreementLinkTarget.href = this.agreementLinkTarget.dataset.fourOhOneUrl;
    } else {
      this.agreementLinkTarget.href = this.agreementLinkTarget.dataset.advisorUrl;
    }
  }
  determinePasswordConfirmationState() {
    const passwordConfirmationErrorLabel = document.querySelector("#firm_password_confirmation_error");
    if (passwordConfirmationErrorLabel) {
      this.passwordInputTarget.classList.add("not-valid");
      this.passwordConfirmationLabelTarget.style.display = "block";
      this.passwordLabelTarget.style.display = "block";
      const passwordConfirmationLabel = document.createElement("label");
      passwordConfirmationLabel.setAttribute("for", "firm_password");
      passwordConfirmationLabel.setAttribute("class", "validation");
      passwordConfirmationLabel.innerHTML = passwordConfirmationErrorLabel.innerHTML;
      this.passwordLabelTarget.insertAdjacentElement("afterend", passwordConfirmationLabel);
    }
  }
}
firm_registration_controller_default.targets = ["agreementLink", "fourOhOneInput", "passwordLabel", "passwordConfirmationLabel", "passwordInput"];
const __vite_glob_0_16 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: firm_registration_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class SelfDirectedPortfolio {
  constructor(components) {
    this.components = components;
  }
  isValid() {
    return this.hasValidComponents() && this.hasValidTotalWeight();
  }
  hasValidTotalWeight() {
    return this.total === 100;
  }
  hasValidComponents() {
    return this.components.every((component) => {
      return parseInteger(component) === Number(component) && parseInteger(component) >= 0 && parseInteger(component) <= 100 && parseFloat(component) % 1 === 0;
    });
  }
  get total() {
    return this.components.map((component) => {
      return parseInteger(component) || 0;
    }).reduce((sum, value) => {
      return sum + value;
    });
  }
}
class self_directed_allocation_selection_controller_default extends Controller {
  connect() {
    this.connectInputListener();
  }
  disconnect() {
    this.disconnectInputListener();
  }
  connectInputListener() {
    this.rollupTableTarget.addEventListener("input", this.refresh.bind(this));
  }
  disconnectInputListener() {
    this.rollupTableTarget.removeEventListener("input", this.refresh.bind(this));
  }
  refresh() {
    this.toggleSubmitButton();
    this.toggleInvalidAdvice();
    this.triggerFormRefresh();
  }
  toggleSubmitButton() {
    if (this.portfolio.isValid()) {
      this.submitButtonTarget.removeAttribute("disabled");
    } else {
      this.submitButtonTarget.setAttribute("disabled", "disabled");
    }
  }
  triggerFormRefresh() {
    if (this.portfolio.isValid()) {
      const event = new Event("change", { bubbles: true });
      this.refreshableElement.dispatchEvent(event);
    }
  }
  toggleInvalidAdvice() {
    this.adviceController.setValid(this.portfolio.isValid());
    this.rollupTableController.setValid(this.portfolio.isValid());
  }
  get refreshableElement() {
    return this.element.querySelector("#refresh");
  }
  get rollupTableController() {
    return this.application.getControllerForElementAndIdentifier(
      this.rollupTableTarget,
      "rollup-table"
    );
  }
  get adviceController() {
    return this.application.getControllerForElementAndIdentifier(
      this.adviceTarget,
      "self-directed-allocation-advice"
    );
  }
  get portfolio() {
    const components = this.rollupTableController.values;
    return new SelfDirectedPortfolio(components);
  }
}
self_directed_allocation_selection_controller_default.targets = ["rollupTable", "submitButton", "advice"];
const __vite_glob_0_28 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: self_directed_allocation_selection_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class managed_etf_portfolio_controller_default extends self_directed_allocation_selection_controller_default {
  toggleSubmitButton() {
    if (this.portfolio.isValid() && this.nameTarget.value !== "") {
      this.submitButtonTarget.removeAttribute("disabled");
    } else {
      this.submitButtonTarget.setAttribute("disabled", "disabled");
    }
  }
  resetTax() {
    this.taxTreatmentTarget.value = "";
    const event = new Event("change", { bubbles: true });
    this.refreshableElement.dispatchEvent(event);
  }
}
managed_etf_portfolio_controller_default.targets = ["name", "taxTreatment"];
const __vite_glob_0_17 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: managed_etf_portfolio_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class mfaCallToActionController extends Controller {
  connect() {
    window.addEventListener("load", () => {
      const PREVENT_MODAL_CLOSE_ERROR = "prevent-modal-close";
      const $modal = $('[data-sc-modal-content="mfa-call-to-action"]');
      $modal.on("sc-Modal.close", () => {
        if ($modal.data("prevent-close") === true) {
          throw PREVENT_MODAL_CLOSE_ERROR;
        }
      });
      window.addEventListener("error", (event) => {
        if (event.error === PREVENT_MODAL_CLOSE_ERROR) {
          event.stopImmediatePropagation();
          event.stopPropagation();
          event.preventDefault();
          return true;
        }
        return false;
      });
      $modal.find(".sc-Modal-close").css("display", "none");
      const $enableForm = $("[data-mfa-call-to-action-enable-form]");
      $enableForm.on("ajax:success", () => {
        window.location.href = $enableForm.data("redirect");
      });
      $enableForm.on("ajax:error", () => {
        throw Error("System error");
      });
      const $skipForm = $("[data-mfa-call-to-action-skip-form]");
      $skipForm.on("ajax:success", () => {
        $modal.data("prevent-close", false);
        $modal.find(".sc-Modal-close").click();
      });
      $skipForm.on("ajax:error", () => {
        throw Error("System error");
      });
    });
  }
}
const __vite_glob_0_18 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mfaCallToActionController
}, Symbol.toStringTag, { value: "Module" }));
class model_portfolios_advisor_announcement_controller_default extends Controller {
  portfoliosStep() {
    this.toggleStep(this.welcomeTarget);
    this.toggleStep(this.portfoliosTarget);
  }
  assignmentStep() {
    this.toggleStep(this.portfoliosTarget);
    this.toggleStep(this.assignmentTarget);
  }
  completionStep() {
    this.toggleStep(this.assignmentTarget);
    this.toggleStep(this.completionTarget);
  }
  toggleStep(el) {
    el.classList.toggle("u-displayNone");
  }
}
model_portfolios_advisor_announcement_controller_default.targets = ["welcome", "portfolios", "assignment", "completion"];
const __vite_glob_0_19 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: model_portfolios_advisor_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class model_portfolios_firm_admin_announcement_controller_default extends Controller {
  portfoliosStep() {
    this.toggleStep(this.welcomeTarget);
    this.toggleStep(this.portfoliosTarget);
  }
  creationStep() {
    this.toggleStep(this.portfoliosTarget);
    this.toggleStep(this.creationTarget);
  }
  completionStep() {
    this.toggleStep(this.creationTarget);
    this.toggleStep(this.completionTarget);
  }
  toggleStep(element) {
    element.classList.toggle("u-displayNone");
  }
}
model_portfolios_firm_admin_announcement_controller_default.targets = ["welcome", "portfolios", "creation", "completion"];
const __vite_glob_0_20 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: model_portfolios_firm_admin_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class navigationController extends Controller {
  close() {
    this.element.classList.remove("is-open");
    document.body.classList.remove("u-overflowHidden");
  }
  clickAway() {
    if (this.element.classList.contains("is-open")) {
      this.close();
    }
  }
  open() {
    this.element.classList.add("is-open");
    document.body.classList.add("u-overflowHidden");
  }
}
const __vite_glob_0_21 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: navigationController
}, Symbol.toStringTag, { value: "Module" }));
class paginated_announcement_controller_default extends Controller {
  nextStep({ target }) {
    const step = parseInt(target.dataset.step, 10);
    if (step === 3) {
      this.closeAndRedirect();
      return;
    }
    const currentStep = document.querySelector(`[data-page="${step}"]`);
    if (currentStep) {
      currentStep.classList.add("u-displayNone");
      const el = document.querySelector(`[data-page="${step + 1}"]`);
      if (el) {
        el.classList.remove("u-displayNone");
      }
    }
  }
  toggleStep(el) {
    el.classList.toggle("u-displayNone");
  }
  closeAndRedirect() {
    const close = document.querySelector(".sc-Modal-close");
    close.click();
    window.location.href = this.redirectHolderTarget.dataset.redirectValue;
  }
}
paginated_announcement_controller_default.values = {
  redirect: String,
  dismissUrl: String
};
paginated_announcement_controller_default.targets = ["divElement", "modal", "redirectHolder"];
const __vite_glob_0_22 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: paginated_announcement_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const appRegistry = {
  Summary: () => import("./SummaryApp-d043d1a8.mjs"),
  SecurityGroupTable: () => import("./SecurityGroupTableApp-41ab0f9d.mjs"),
  MfaSudoChallengeFlow: () => import("./MfaSudoChallengeFlowApp-90651c83.mjs"),
  MfaSmsSetupFlow: () => import("./MfaSmsSetupFlowApp-c7e355af.mjs"),
  TieredBillingConfigurationForm: () => import("./TieredBillingConfigurationFormApp-07316b35.mjs"),
  FourOhOneKLead: () => import("./FourOhOneKLeadApp-4f421630.mjs"),
  FourOhOneKDashboard: () => import("./FourOhOneKDashboardApp-b900c79a.mjs"),
  IraConversionFlow: () => import("./IraConversionFlowApp-cad6384f.mjs"),
  CoPilot: () => import("./CoPilotApp-36c059e4.mjs"),
  CustomPortfolios: () => import("./CustomPortfoliosApp-5299b87a.mjs"),
  CustomPortfoliosV2: () => import("./CustomPortfoliosV2App-d52ddb79.mjs"),
  Clients: () => import("./ClientsApp-0510f332.mjs"),
  AddAccounts: () => import("./AddAccountsApp-59b67dac.mjs"),
  AdvisorMfaSetupTotp: () => import("./AdvisorMfaSetupTotpApp-96b1a9cb.mjs"),
  EtfPortfolios: () => import("./EtfPortfoliosApp-f6df832e.mjs"),
  GoldmanSachsTaxSmartBondAdviceApp: () => import("./GoldmanSachsTaxSmartBondAdviceApp-ab9d0457.mjs"),
  FirmIntegrations: () => import("./FirmIntegrationsApp-0451d947.mjs"),
  GoalCreationFlow: () => import("./GoalCreationFlowApp-9487bb1c.mjs"),
  Solo401kConversion: () => import("./Solo401kConversionApp-c3cef4d1.mjs"),
  Household: () => import("./HouseholdApp-aa060caf.mjs"),
  Start401kConversionBannerApp: () => import("./Start401kConversionBannerApp-af4ef9e7.mjs"),
  PostApproval401kBannerApp: () => import("./PostApproval401kBannerApp-a20596e1.mjs")
};
const retry = (fn, retriesLeft = 5, interval = 1e3) => {
  return new Promise((resolve, reject) => {
    fn().then(resolve).catch((error) => {
      if (retriesLeft === 0) {
        reject(error);
        return;
      }
      setTimeout(() => {
        retry(fn, retriesLeft - 1, interval).then(resolve, reject);
      }, interval);
    });
  });
};
const getApp = (name) => React.lazy(() => retry(appRegistry[name]));
const appShell = {
  getApp
};
const FullPageLoader = () => /* @__PURE__ */ jsx(Flex, { height: "100vh", children: /* @__PURE__ */ jsx(Loader, { isLoading: true }) });
const FeatureFlagContext = React.createContext(null);
const FeatureFlagProvider = ({ children }) => {
  const featureFlagMap = {};
  const getFeatureFlag = (splitName) => {
    return featureFlagMap[splitName];
  };
  return /* @__PURE__ */ jsx(FeatureFlagContext.Provider, { value: { getFeatureFlag }, children });
};
class reactAppController extends Controller {
  connect() {
    const App = Sentry.withProfiler(this.app, { name: this.name });
    if (App) {
      const root = createRoot(this.element);
      root.render(
        /* @__PURE__ */ jsx(
          Sentry.ErrorBoundary,
          {
            fallback: GlobalErrorFallback,
            beforeCapture: (scope) => {
              scope.setTransactionName(this.name);
            },
            children: /* @__PURE__ */ jsx(React.Suspense, { fallback: this.suspenseFallback, children: /* @__PURE__ */ jsx(StyleClosetThemeProvider, { theme: this.theme, children: /* @__PURE__ */ jsx(DataFetchProvider, { children: /* @__PURE__ */ jsx(FeatureFlagProvider, { children: /* @__PURE__ */ jsx(App, { ...this.initialProps }) }) }) }) })
          }
        )
      );
    } else {
      console.warn(`Could not resolve app with name: '${this.name}'`);
    }
  }
  get app() {
    return appShell.getApp(this.name);
  }
  get name() {
    return this.data.get("name");
  }
  get suspenseFallback() {
    var _a;
    let fallback = /* @__PURE__ */ jsx(FullPageLoader, {});
    if (((_a = this.initialProps) == null ? void 0 : _a.suspenseFallback) === false) {
      fallback = null;
    }
    return fallback;
  }
  get theme() {
    var _a;
    return ((_a = document.querySelector('meta[name="theme"]')) == null ? void 0 : _a.content) || "default";
  }
  get initialProps() {
    return JSON.parse(this.data.get("initial-props") || "{}");
  }
}
const __vite_glob_0_23 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: reactAppController
}, Symbol.toStringTag, { value: "Module" }));
class rebalance_settings_controller_default extends Controller {
  connect() {
    this.determineRebalanceEnabledLabel();
  }
  determineRebalanceEnabledLabel() {
    if (this.rebalanceEnabledInputTarget.checked) {
      this.rebalanceEnabledLabelTarget.innerText = "On";
      this.driftThresholdPercentInputTarget.readOnly = false;
      this.driftThresholdPercentInputTarget.classList.remove("u-backgroundColor-bmtGrey10", "u-color-bmtGrey50");
      this.rebalanceInfoTarget.classList.add("hidden");
    } else {
      this.rebalanceEnabledLabelTarget.innerText = "Off";
      this.driftThresholdPercentInputTarget.readOnly = true;
      this.driftThresholdPercentInputTarget.classList.add("u-backgroundColor-bmtGrey10", "u-color-bmtGrey50");
      this.rebalanceInfoTarget.classList.remove("hidden");
    }
  }
}
rebalance_settings_controller_default.targets = ["rebalanceEnabledInput", "rebalanceEnabledLabel", "driftThresholdPercentInput", "rebalanceInfo"];
const __vite_glob_0_24 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rebalance_settings_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class ReturnsGraph {
  constructor(element, options) {
    const DEFAULTS = {
      margin: {
        top: 20,
        right: 60,
        left: 0,
        bottom: 50
      },
      graphHeight: Math.min(0.75 * element.parentElement.clientWidth, 375),
      tooltipClass: ".ProjectionGraph-tooltip",
      displayYAxis: false,
      interpolation: curveBasis
    };
    this.settings = { ...DEFAULTS, ...options, element };
    this.settings.width = this.settings.element.parentElement.clientWidth - this.settings.margin.right;
    this.settings.height = this.settings.graphHeight - this.settings.margin.top - this.settings.margin.bottom;
  }
  draw() {
    this.emptyLayout();
    this.setUpScales();
    this.setUpGenerators();
    this.createLayout();
    this.drawData();
    this.drawHoverBar();
    this.initHover();
  }
  emptyLayout() {
    const svg = this.settings.element;
    while (svg.firstChild) {
      svg.removeChild(svg.firstChild);
    }
  }
  setUpScales() {
    const yMin = this.settings.minValue;
    const yMax = this.settings.maxValue;
    this.scales = {
      x: scaleTime().domain(
        extent(this.settings.valuesByDate, (d) => {
          return d.date;
        })
      ).range([0, this.settings.width]),
      y: scaleLinear().domain([yMin, yMax]).range([this.settings.height, 0]).nice()
    };
  }
  setUpGenerators() {
    const { scales } = this;
    const { interpolation } = this.settings;
    const axisDateFormat = timeFormat(this.settings.termYears > 10 ? "%Y" : "%-m/%Y");
    const xTicks = this.settings.width < 500 ? 3 : 6;
    const yTicks = this.settings.width < 500 ? 4 : 8;
    this.generators = {
      xAxis: axisBottom(scales.x).tickSize(10).ticks(xTicks).tickPadding(8).tickFormat(axisDateFormat),
      yAxis: axisRight(scales.y).tickSize(10).ticks(yTicks).tickPadding(10).tickFormat((d) => {
        return `${d}%`;
      }),
      line: {
        expected: line().x((d) => scales.x(d.date)).y((d) => scales.y(d.expected)).curve(interpolation),
        zero: line().x((d) => scales.x(d.date)).y(scales.y(0))
      },
      area: {
        midRange: area().x((d) => scales.x(d.date)).y0((d) => scales.y(d.tenPercentile)).y1((d) => scales.y(d.ninetyPercentile)).curve(interpolation)
      }
    };
  }
  createLayout() {
    this.svg = select("svg.ProjectionGraph-svg").attr("width", this.settings.width + this.settings.margin.left + this.settings.margin.right).attr("height", this.settings.height + this.settings.margin.top + this.settings.margin.bottom).on("mousemove", () => {
      this.updateHover(this.settings.element);
    }).on("mouseout", () => {
      this.hideHover();
    }).append("g").attr("transform", `translate(${this.settings.margin.left},${this.settings.margin.top})`);
    this.svg.append("g").attr("class", "ProjectionGraph-axis").attr("transform", `translate(0,${this.settings.height})`).call(this.generators.xAxis);
    this.svg.append("g").attr("class", "ProjectionGraph-axis--y ProjectionGraph-axis").attr("transform", `translate(${this.settings.width} , 0)`).call(this.generators.yAxis);
    this.svg.selectAll("g.tick").attr("class", "ProjectionGraph-axisTick ProjectionGraph-label");
  }
  drawData() {
    this.drawArea("midRange");
    this.drawLine("expected");
    this.drawLine("zero");
    this.drawCircle("ninetyPercentile");
    this.drawCircle("tenPercentile");
    this.drawCircle("expected");
  }
  drawArea(type) {
    this.svg.append("path").datum(this.settings.valuesByDate).attr("class", `ProjectionGraph-area ProjectionGraph-area--${type}`).attr("d", this.generators.area[type]);
  }
  drawLine(type) {
    this.svg.append("path").datum(this.settings.valuesByDate).attr("class", `ProjectionGraph-line ProjectionGraph-line--${type}`).attr("d", this.generators.line[type]);
  }
  drawCircle(type) {
    this.svg.append("circle").attr("r", 3).attr("class", `ProjectionGraph-hover ProjectionGraph-circle ProjectionGraph-circle--${type}`).attr("data-type", type);
  }
  drawHoverBar() {
    this.svg.append("path").attr("class", "ProjectionGraph-hover ProjectionGraph-bar");
  }
  initHover() {
    const lastPoint = this.settings.valuesByDate[this.settings.valuesByDate.length - 1];
    this.updateHoverBar(lastPoint);
    this.updateTooltip({ point: lastPoint, mouseX: 0 });
    this.updateCircles(lastPoint);
    this.hideHover();
  }
  updateHoverBar(point) {
    const x = this.scales.x(new Date(point.date));
    select(".ProjectionGraph-hover.ProjectionGraph-bar").classed("ProjectionGraph-hover--show", true).attr("d", `M${x},${this.settings.height}L${x},${0}`);
  }
  updateTooltip(options) {
    const tooltip = document.querySelector(this.settings.tooltipClass);
    const { point } = options;
    const toolWidth = tooltip.offsetWidth;
    const offset = options.mouseX - toolWidth;
    const tooltipYPosition = this.settings.element.parentElement.offsetTop;
    tooltip.querySelector(".ProjectionGraph-tooltipDate").innerHTML = // @ts-ignore We need a way to manually test this before getting rid of the parseInteger to match the DataPoint interface
    `Year ${this.dateFormat(new Date(parseInteger(point.date)))} cumulative returns`;
    Array.from(tooltip.querySelectorAll(".ProjectionGraph-tooltipValue")).forEach((item) => {
      const type = item.getAttribute("data-value-type");
      const f = format("+");
      item.innerHTML = // @ts-ignore We need a way to manually test this before getting rid of the parseInteger to match the DataPoint interface
      parseInteger(point[type]) === 0 ? `${parseInteger(point[type])}%` : `${f(parseInteger(point[type]))}%`;
    });
    function updateTooltipBoxPadding(scales) {
      const leftValue = scales.x(point.date) + 31 - (offset > 0 ? toolWidth - 2 : 1);
      tooltip.style.left = `${leftValue}px`;
      tooltip.style.top = `${tooltipYPosition}px`;
      tooltip.classList.add("ProjectionGraph-hover--show");
    }
    updateTooltipBoxPadding(this.scales);
  }
  // eslint-disable-next-line no-unused-vars
  updateCircles(point) {
    selectAll(".ProjectionGraph-circle").classed("ProjectionGraph-hover--show", true).attr("cx", this.scales.x(point.date));
    Array.from(document.querySelectorAll(".ProjectionGraph-circle")).forEach((circle) => {
      const type = circle.getAttribute("data-type");
      circle.setAttribute("cy", `${this.scales.y(point[type])}`);
    });
  }
  updateHover(el) {
    const container = el;
    const mouseX = mouse(container)[0] - this.settings.margin.left;
    const mouseY = mouse(container)[1];
    if (mouseX >= 0 && mouseX <= this.settings.width && mouseY >= 0 && mouseY <= this.settings.height) {
      const exactDate = this.scales.x.invert(mouseX);
      const point = this.getClosestDataPoint(exactDate);
      this.updateHoverBar(point);
      this.updateTooltip({
        point,
        mouseX
      });
      this.updateCircles(point);
    } else {
      this.hideHover();
    }
  }
  getClosestDataPoint(date) {
    const bisect = bisector((d) => d.date);
    const index2 = Math.min(bisect.right(this.settings.valuesByDate, date), this.settings.valuesByDate.length - 1);
    return this.settings.valuesByDate[index2];
  }
  hideHover() {
    selectAll(".ProjectionGraph-hover").classed("ProjectionGraph-hover--show", false);
  }
  dateFormat(date) {
    return timeFormat("%Y")(date);
  }
}
class returns_graph_controller_default extends Controller {
  connect() {
    this.draw();
    this.connectResizeListener();
  }
  disconnect() {
    this.disconnectResizeListener();
  }
  draw() {
    const chart = new ReturnsGraph(this.svgTarget, this.graphOptions);
    chart.draw();
  }
  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener("resize", this.resizeListener);
  }
  disconnectResizeListener() {
    window.removeEventListener("resize", this.resizeListener);
  }
  get graphOptions() {
    return {
      minValue: parseInteger(this.data.get("min-value")),
      maxValue: parseInteger(this.data.get("max-value")),
      displayYAxis: Boolean(this.data.get("display-y-axis")),
      termYears: parseInteger(this.data.get("term-years")),
      valuesByDate: JSON.parse(this.data.get("values-by-date"))
    };
  }
}
returns_graph_controller_default.targets = ["svg"];
const __vite_glob_0_25 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: returns_graph_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class rollup_table_controller_default extends Controller {
  connect() {
    this.sectionTargets.forEach((section) => this.updateSectionLabel(section));
  }
  valueChanged() {
    this.sectionTargets.forEach((section) => this.updateSectionLabel(section));
    this.triggerInputEvent();
  }
  updateSectionLabel(section) {
    const label = section.querySelector(
      `[data-target="rollup-table.output"][data-section="${section.dataset.section}"]`
    );
    label.innerHTML = this.totalForSection(section).toString();
  }
  triggerInputEvent() {
    const event = new Event("input");
    this.element.dispatchEvent(event);
  }
  totalForSection(section) {
    const inputs = section.querySelectorAll('input[data-target="rollup-table.input"]');
    const total = Array.from(inputs).map((input) => {
      return Number(input.value) || 0;
    }).reduce((sum, value) => {
      return sum + value;
    });
    return total;
  }
  setValid(valid) {
    if (valid) {
      this.element.classList.remove("invalid");
    } else {
      this.element.classList.add("invalid");
    }
  }
  get inputs() {
    return this.element.querySelectorAll('input[data-target="rollup-table.input"]');
  }
  get values() {
    return Array.from(this.inputs).map((input) => input.value);
  }
}
rollup_table_controller_default.targets = ["section", "input", "output"];
const __vite_glob_0_26 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rollup_table_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class selfDirectedAllocationAdviceController extends Controller {
  connect() {
    this.connectInputListener();
  }
  disconnect() {
    this.disconnectInputListener();
  }
  connectInputListener() {
    this.tabNavCardTarget.addEventListener(
      "change",
      this.redrawGraphs.bind(this)
    );
  }
  disconnectInputListener() {
    this.tabNavCardTarget.removeEventListener(
      "change",
      this.redrawGraphs.bind(this)
      // eslint-disable-line @typescript-eslint/no-unsafe-argument
    );
  }
  redrawGraphs() {
    this.returnsGraphController.draw();
  }
  setValid(valid) {
    if (valid) {
      this.element.classList.remove("invalid");
    } else {
      this.element.classList.add("invalid");
    }
  }
  get tabNavCardTarget() {
    return this.element.querySelector(".sc-TabNavCard");
  }
  get tabNavController() {
    return this.application.getControllerForElementAndIdentifier(this.tabNavCardTarget, "tab-nav-card");
  }
  get returnsGraphTarget() {
    return this.element.querySelector(
      '.SelfDirectedAllocationSelection-returnsProjectionComponent [data-controller="returns-graph"]'
    );
  }
  get returnsGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.returnsGraphTarget,
      "returns-graph"
    );
  }
}
const __vite_glob_0_27 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: selfDirectedAllocationAdviceController
}, Symbol.toStringTag, { value: "Module" }));
class short_form_client_invite_controller_default extends Controller {
  connect() {
    const accountType = this.accountTypeInputTarget.value;
    if (accountType) {
      this.updateData(this.accountTypeInputTarget);
    }
  }
  updateLegalAccountType({ target }) {
    this.updateData(target);
  }
  updateData(target) {
    const { value } = target;
    this.accountTypeInputTarget.value = value;
    this.updateURL(value);
    this.hideOrShowPortfolioData(value);
  }
  updateURL(accountType) {
    const url = new URL(this.directLinkTarget.value);
    url.searchParams.set("account_type", accountType);
    this.directLinkTarget.value = url.toString();
  }
  hideOrShowPortfolioData(value) {
    if (value === "individual_cash_reserve") {
      this.setHiddenPortfolioData(true);
    } else {
      this.setHiddenPortfolioData(false);
    }
  }
  setHiddenPortfolioData(hidden) {
    this.portfolioStrategyTarget.hidden = hidden;
    this.allocationTarget.hidden = hidden;
    this.autoAdjustTarget.hidden = hidden;
  }
}
short_form_client_invite_controller_default.targets = [
  "accountTypeInput",
  "form",
  "accountSelect",
  "directLink",
  "portfolioStrategy",
  "allocation",
  "autoAdjust"
];
const __vite_glob_0_29 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: short_form_client_invite_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class stripe_portal_controller_default extends Controller {
  stripeLoader() {
    this.loaderTarget.classList.remove("u-displayNone");
  }
  redirectStripePortal() {
    this.stripeLoader();
    document.body.classList.add("stripe-non-scrollable");
    setTimeout(() => {
      this.formTarget.submit();
    }, 1e3);
  }
}
stripe_portal_controller_default.targets = ["loader", "form"];
const __vite_glob_0_30 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: stripe_portal_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class tabNavCardController extends Controller {
  connect() {
    if (this.noActiveItemSet) {
      this.activateItem(this.firstItemKey);
    }
  }
  get firstItemKey() {
    return this.firstItemTab.getAttribute("data-key");
  }
  get firstItemTab() {
    return this.element.querySelector(".sc-TabNavCard-itemTab");
  }
  get activeItemTab() {
    return this.element.querySelector(".sc-TabNavCard-itemTab.is-active");
  }
  get activeItemContent() {
    return this.element.querySelector(".sc-TabNavCard-itemContent.is-active");
  }
  get noActiveItemSet() {
    return !this.activeItemTab;
  }
  clickItemTab(event) {
    event.preventDefault();
    const target = event.target;
    const newlyActiveItemKey = target.getAttribute("data-key");
    this.deactivateActiveItem();
    this.activateItem(newlyActiveItemKey);
    this.triggerChangeEvent();
  }
  triggerChangeEvent() {
    const event = new Event("change");
    this.element.dispatchEvent(event);
  }
  deactivateActiveItem() {
    this.activeItemTab.classList.remove("is-active");
    this.activeItemContent.classList.remove("is-active");
  }
  activateItem(key) {
    const newlyActiveItemTab = this.element.querySelector(`.sc-TabNavCard-itemTab[data-key="${key}"]`);
    const newlyActiveItemContent = this.element.querySelector(`.sc-TabNavCard-itemContent[data-key="${key}"]`);
    newlyActiveItemTab.classList.add("is-active");
    newlyActiveItemContent.classList.add("is-active");
  }
}
const __vite_glob_0_31 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tabNavCardController
}, Symbol.toStringTag, { value: "Module" }));
class tax_id_collection_controller_default extends Controller {
  connect() {
    const selected = this.taxClassificationTargets.find((button) => button.checked);
    this.show(selected, this.taxClassificationLlcTarget, "llc");
    this.show(selected, this.taxClassificationOtherTarget, "other");
  }
  formatEin(event) {
    if (!/[-]/.test(this.taxIdTarget.value) && event.code !== "Minus") {
      this.taxIdTarget.value = this.taxIdTarget.value.replace(/^(.{2})/, "$1-");
    }
  }
  change() {
    const llcInput = this.taxClassificationLlcTarget.querySelector("select");
    const otherInput = this.taxClassificationOtherTarget.querySelector("input");
    const selected = this.taxClassificationTargets.find((button) => button.checked);
    this.taxClassificationLlcTarget.setAttribute("hidden", "true");
    this.taxClassificationOtherTarget.setAttribute("hidden", "true");
    llcInput.value = "";
    otherInput.value = "";
    this.show(selected, this.taxClassificationLlcTarget, "llc");
    this.show(selected, this.taxClassificationOtherTarget, "other");
  }
  show(selected, wrapper, val) {
    if (selected && selected.value === val) {
      wrapper.removeAttribute("hidden");
    }
  }
}
tax_id_collection_controller_default.targets = ["taxId", "taxClassification", "taxClassificationLlc", "taxClassificationOther"];
const __vite_glob_0_32 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tax_id_collection_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const getCommonFetchConfig = (method = "post") => ({
  headers: {
    "X-CSRF-Token": getCsrfToken(),
    "X-REQUESTED-WITH": "XMLHttpRequest",
    "Content-Type": "application/json"
  },
  credentials: "same-origin",
  method
});
class tax_impact_controller_default extends Controller {
  connect() {
    const goalId = this.data.get("goalId");
    const isTaxableGoal = this.data.get("isTaxableGoal") === "true";
    if (isTaxableGoal) {
      this.rebalanceButton = document.querySelector(
        `[data-sc-modal-target="[data-sc-modal-content='goal-${goalId}-rebalance-me-now']"`
      );
      this.closeIcon = this.modalTarget.querySelector(".sc-Modal-close");
      this.setListeners();
    } else {
      this.removeOutputComponent();
    }
  }
  setListeners() {
    this.addRebalanceButtonListener();
    this.addCloseModalListener();
    this.addContinueButtonListener();
  }
  addRebalanceButtonListener() {
    if (this.rebalanceButton) {
      this.rebalanceButton.addEventListener("click", () => {
        this.loadPartial();
      });
    }
  }
  addCloseModalListener() {
    if (this.closeIcon) {
      this.closeIcon.addEventListener("click", () => {
        this.refreshOutputComponent();
      });
    }
    this.cancelButtonTarget.addEventListener("click", () => {
      this.refreshOutputComponent();
    });
  }
  addContinueButtonListener() {
    this.continueButtonTarget.addEventListener("click", () => {
      this.disableCancelButton();
    });
  }
  refreshOutputComponent() {
    this.outputComponentTarget.innerText = "Loading Tax Impact Preview...";
  }
  removeOutputComponent() {
    this.outputComponentTarget.style.display = "none";
  }
  disableCancelButton() {
    this.cancelButtonTarget.disabled = true;
  }
  loadPartial() {
    fetch(`/goals/${this.data.get("goalId")}/tax_impact`, getCommonFetchConfig("get")).then((response) => response.text()).then((partial) => {
      this.outputComponentTarget.innerHTML = partial;
    }).catch((error) => {
      Sentry$1.captureException(error);
      this.outputComponentTarget.innerText = "We can't complete this request. Please try again.";
    });
  }
}
tax_impact_controller_default.targets = ["modal", "taxComponent", "outputComponent", "cancelButton", "continueButton"];
const __vite_glob_0_33 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tax_impact_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class toast_controller_default extends Controller {
  userDismissed(event) {
    event.preventDefault();
    this.notificationTarget.classList.add("u-hidden");
    document.cookie = this.writeCookie;
  }
  get writeCookie() {
    const date = /* @__PURE__ */ new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1e3);
    const expires = `; expires=${date.toUTCString()}`;
    return `${this.toastCookieKey}=user_dismissed${expires}; path=/`;
  }
  get toastCookieKey() {
    return this.notificationTarget.getAttribute("data-toast-cookie");
  }
}
toast_controller_default.targets = ["notification", "dismissLink"];
const __vite_glob_0_34 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: toast_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class token_opt_out_controller_default extends Controller {
  toggleOptOut() {
    const isChecked = !this.toggleOptOutInputTarget.checked;
    this.toggleOptOutInputTarget.checked = isChecked;
    if (isChecked) {
      this.toggleOptOutButtonTarget.classList.remove("sc-SecondaryButton", "sc-SecondaryButton--small");
      this.toggleOptOutButtonTarget.classList.add("sc-PrimaryButton", "sc-PrimaryButton--small");
      this.toggleOptOutButtonTarget.innerHTML = "Unblock";
    } else {
      this.toggleOptOutButtonTarget.classList.remove("sc-PrimaryButton", "sc-PrimaryButton--small");
      this.toggleOptOutButtonTarget.classList.add("sc-SecondaryButton", "sc-SecondaryButton--small");
      this.toggleOptOutButtonTarget.innerHTML = "Block";
    }
  }
}
token_opt_out_controller_default.targets = ["toggleOptOutButton", "toggleOptOutInput"];
const __vite_glob_0_35 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: token_opt_out_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class ultimateAdvisorController extends Controller {
  connect() {
    try {
      this.load();
    } catch {
      setTimeout(() => this.load(), 500);
    }
  }
  load() {
    zE("messenger:on", "open", () => this.auth());
  }
  auth() {
    zE("messenger", "loginUser", (callback) => {
      fetch("/ultimate_authentication").then((response) => response.text()).then((data) => callback(data)).catch((error) => Sentry$1.captureException(error));
    });
  }
}
const __vite_glob_0_36 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ultimateAdvisorController
}, Symbol.toStringTag, { value: "Module" }));
const appConfig = window.BMT.config;
const index = "";
const controllers = /* @__PURE__ */ Object.assign({ "./src/controllers/acats-assets-selection-controller.ts": __vite_glob_0_0, "./src/controllers/add-account-solo-401k-tcp-controller.ts": __vite_glob_0_1, "./src/controllers/advisor-announcement-controller.ts": __vite_glob_0_2, "./src/controllers/advisor-crypto-goal-confirm-controller.ts": __vite_glob_0_3, "./src/controllers/advisor-goal-creation-flow-account-ownership-configuration-controller.ts": __vite_glob_0_4, "./src/controllers/asset-row-controller.ts": __vite_glob_0_5, "./src/controllers/billing-configuration-rate-fields-controller.ts": __vite_glob_0_6, "./src/controllers/bullet-chart-controller.ts": __vite_glob_0_7, "./src/controllers/client-envelope-announcement-controller.ts": __vite_glob_0_8, "./src/controllers/clipboard-controller.ts": __vite_glob_0_9, "./src/controllers/custom-model-portfolios-announcement-controller.ts": __vite_glob_0_10, "./src/controllers/datum-mask-controller.ts": __vite_glob_0_11, "./src/controllers/disassociation-modal-controller.ts": __vite_glob_0_12, "./src/controllers/feature-tour-controller.ts": __vite_glob_0_13, "./src/controllers/firm-fee-configuration-acceptance-controller.ts": __vite_glob_0_14, "./src/controllers/firm-fee-configuration-acceptance-stripe-controller.ts": __vite_glob_0_15, "./src/controllers/firm-registration-controller.ts": __vite_glob_0_16, "./src/controllers/managed-etf-portfolio-controller.ts": __vite_glob_0_17, "./src/controllers/mfa-call-to-action-controller.ts": __vite_glob_0_18, "./src/controllers/model-portfolios-advisor-announcement-controller.ts": __vite_glob_0_19, "./src/controllers/model-portfolios-firm-admin-announcement-controller.ts": __vite_glob_0_20, "./src/controllers/navigation-controller.ts": __vite_glob_0_21, "./src/controllers/paginated-announcement-controller.ts": __vite_glob_0_22, "./src/controllers/react-app-controller.tsx": __vite_glob_0_23, "./src/controllers/rebalance-settings-controller.ts": __vite_glob_0_24, "./src/controllers/returns-graph-controller.ts": __vite_glob_0_25, "./src/controllers/rollup-table-controller.ts": __vite_glob_0_26, "./src/controllers/self-directed-allocation-advice-controller.ts": __vite_glob_0_27, "./src/controllers/self-directed-allocation-selection-controller.ts": __vite_glob_0_28, "./src/controllers/short-form-client-invite-controller.tsx": __vite_glob_0_29, "./src/controllers/stripe-portal-controller.ts": __vite_glob_0_30, "./src/controllers/tab-nav-card-controller.ts": __vite_glob_0_31, "./src/controllers/tax-id-collection-controller.ts": __vite_glob_0_32, "./src/controllers/tax-impact-controller.ts": __vite_glob_0_33, "./src/controllers/toast-controller.ts": __vite_glob_0_34, "./src/controllers/token-opt-out-controller.ts": __vite_glob_0_35, "./src/controllers/ultimate-advisor-controller.ts": __vite_glob_0_36 });
const definitions = definitionsFromGlob(controllers);
const sentryConfig = {
  sentryApiToken: appConfig.sentryApiToken || "",
  sentryEnvironment: appConfig.sentryEnvironment || "",
  sentryRelease: appConfig.sentryRelease || "",
  isReplayEnabled: false,
  sentryErrorReplaySampleRate: 1,
  user: appConfig.user,
  sentryWhitelistUrls: ["betterment.com", "app.bettermentadvisorsolutions.com", "clients.betterment.com"]
};
const dataDogConfig = {
  applicationId: appConfig.dataDogApplicationId,
  clientToken: appConfig.dataDogClientToken,
  env: appConfig.dataDogEnv || "development",
  site: "datadoghq.com",
  service: "institutional",
  replaySampleRate: 0,
  isRumEnabled: appConfig.dataDogEnabled,
  isLoggingEnabled: false,
  allowedTracingUrls: [/https:\/\/*\.bettermentforadvisors\.com/, /https:\/\/*\.betterment\.com/]
};
const testTrackAnalytics = {
  trackAssignment: function(_visitorId, assignment, callback) {
    track(
      "SplitAssigned",
      {
        splitName: assignment.getSplitName(),
        splitVariant: assignment.getVariant() ?? "",
        splitContext: assignment.getContext()
      },
      () => callback(true)
    );
  },
  alias: () => {
  },
  identify: () => {
  }
};
function startStimulusApplication() {
  TestTrack.initialize({
    analytics: testTrackAnalytics,
    errorLogger: (message) => Sentry$1.captureException(`test_track ${message}`)
  });
  const bootstrapper = new StimulusAppBootstrapper(definitions, sentryConfig, dataDogConfig);
  bootstrapper.initialize();
}
export {
  FullPageLoader as F,
  ReturnsGraph as R,
  appConfig as a,
  getCsrfToken as g,
  parseInteger as p,
  startStimulusApplication as s
};
//# sourceMappingURL=index-9d42677e.mjs.map
